// actions -> groups
//
// Group shape: same as action, plus { isBus, actions[] }.
// Grouping rule: same kind, same info.primary (case/space-insensitive), |Δtime| ≤ 5 min.

const GROUP_TIME_TOLERANCE_MS = 5 * 60 * 1000;

// Normalize for *comparison only* — display keeps the original casing of
// whichever action seeds the group. Collapses case + repeated whitespace so
// "Onnibus 44", "OnniBus 44", and "OnniBus  44" all match.
const normName = (s) => (s || "").trim().toLowerCase().replace(/\s+/g, " ");

export function groupActions(actions = []) {
  const groups = [];

  for (const action of actions) {
    const actionKey = normName(action.info.primary);

    const matched = groups.find(
      (g) =>
        g.kind === action.kind &&
        normName(g.info.primary) === actionKey &&
        action.time &&
        g.time &&
        Math.abs(action.time - g.time) <= GROUP_TIME_TOLERANCE_MS
    );

    if (matched) {
      matched.actions.push(action);
      if (action.windowEnd && (!matched.windowEnd || action.windowEnd > matched.windowEnd)) {
        matched.windowEnd = action.windowEnd;
      }
    } else {
      groups.push({
        kind:      action.kind,
        time:      action.time,
        info:      action.info,
        isBus:     !!action.busInfo,
        actions:   [action],
        ...(action.windowEnd ? { windowEnd: action.windowEnd } : {}),
      });
    }
  }

  groups.sort((a, b) => {
    if (!a.time && !b.time) return 0;
    if (!a.time) return 1;
    if (!b.time) return -1;
    return a.time - b.time;
  });

  return groups;
}